
import {
  Component, Emit, Prop, Vue,
} from 'nuxt-property-decorator'
import { globalLabelAsString } from '../../shared/general/services/StoreService'
import { ITeaserData } from '../../shared/general/interfaces/ITeaserData'
import { TTeaserSearchResult } from '../../shared/general/interfaces/TTeaserSearchResult'
import getTeaserImage, { ISmartSearchMediaHost } from '../../shared/smartsearch/ExtractTeaserImage'

@Component({
  name: 'ServiceOverview',
  components: {
    TeaserResults: () => import('../teaser/TeaserResults.vue'),
  },
})
export default class ServiceOverview extends Vue {
  @Prop({ default: () => [] }) searchResults! : TTeaserSearchResult[]

  @Prop({ required: true }) numberOfTotalResults! : number

  @Prop({ default: false }) showLoadingAnimation! : boolean

  private get teasers () : ITeaserData[] {
    const smartSearchMediaHost : ISmartSearchMediaHost = {
      mediaHost: this.$config.SMART_SEARCH_MEDIA_HOST,
      projectId: this.$config.FSXA_PROJECT_ID,
      remotes: this.$config.FSXA_REMOTES,
    }
    return this.searchResults.map((searchResult : TTeaserSearchResult) : ITeaserData => ({
      headline: searchResult.headline,
      text: searchResult.text,
      link: {
        url: searchResult.link,
        label: globalLabelAsString('services_details_label'),
        iconName: 'chevron-right',
      },
      image: getTeaserImage(
        smartSearchMediaHost,
        searchResult.image,
        searchResult.templateUid,
        searchResult.imageAlt,
        searchResult.imageDecorative,
      ),
      mediaType: searchResult.image ? 'image' : 'text',
      aspectRatio: '16:9',
      forceRatio: true,
      teaserVariant: 'vertical',
    }))
  }

  @Emit('load-more-search-results')
  private loadMoreSearchResults () : void {}
}
